var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Profile_",
    "data-name": "Icon / Profile ",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "account_circle-black-18dp_1_",
    "data-name": "account_circle-black-18dp (1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10,20A10,10,0,1,1,20,10,10.011,10.011,0,0,1,10,20Zm0-5.5c-1.982,0-4.517.915-4.93,1.78a7.926,7.926,0,0,0,9.86,0,3.419,3.419,0,0,0-1.918-1.228A9.645,9.645,0,0,0,10,14.5Zm0-2c1.451,0,4.914.57,6.36,2.33A7.92,7.92,0,0,0,18,10,8,8,0,0,0,2,10a7.919,7.919,0,0,0,1.64,4.83C5.086,13.07,8.55,12.5,10,12.5ZM10,11a3.491,3.491,0,1,1,2.478-1.022A3.479,3.479,0,0,1,10,11Zm0-5a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,10,6Z",
    transform: "translate(2 2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon-profile.0282becdc325ad41110355767b3368cd.svg";
export { ForwardRef as ReactComponent };